import { render } from "./BurgerMenuPc.vue?vue&type=template&id=9a60ced4&scoped=true"
import script from "./BurgerMenuPc.vue?vue&type=script&lang=js"
export * from "./BurgerMenuPc.vue?vue&type=script&lang=js"

import "./BurgerMenuPc.vue?vue&type=style&index=0&id=9a60ced4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a60ced4"]])

export default __exports__